import React from "react";
import ReactExport from "react-data-export";
import PropTypes from "prop-types";
import { iconDownloadHead } from "./icons";
import moment from "moment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ExcelSchema = ({ dataIn }) => {
  return (
    <ExcelFile
      filename={`Reporte Documentos del ${moment(new Date()).format(
        "DD-MM-YYYY"
      )}`}
      element={
        <div className=" paragraph paragraph-12 pointer d-align-center">
          {iconDownloadHead} Descargar Reporte
        </div>
      }
    >
      <ExcelSheet data={dataIn} name="Documentos">
        <ExcelColumn
          label="Emisión"
          value={(col) => moment(col.broadcast).format("YYYY/MM/DD")}
        />
        <ExcelColumn
          label="Tipo de Documento"
          value={(col) => ((col.docType === "01" && "FACTURA") || (col.docType === "07" &&  "NOTA DE CREDITO") || (col.docType === "02" &&  "RECIBO X HONORARIO"))}
        />
        <ExcelColumn label="Número Documento" value="docNumber" />
        <ExcelColumn
          label="Tipo Documento Proveedor"
          value={(col) => "R.U.C."}
        />
        <ExcelColumn label="Doc. Proveedor" value="clientDoc" />
        <ExcelColumn label="Nombre Proveedor" value="clientName" />
        <ExcelColumn label="Moneda" value="currency" />
        <ExcelColumn label="Importe" value="amount" />
        <ExcelColumn label="Impuestos IGV" value="taxes" />
        <ExcelColumn label="No Gravado" value="" />
        <ExcelColumn label="Otros Cargos / Descuentos" value="otherCharge" />
        <ExcelColumn label="Impuesto Bolsas Plásticas" value="" />
        <ExcelColumn label="Total" value="total" />
        <ExcelColumn
          label="Recepción"
          value={(col) => moment(col.reception).format("YYYY/MM/DD")}
        />
        <ExcelColumn label="Estado Sunat" value="sunatStatus" />
        <ExcelColumn label="Descripción Estado Sunat" value={(col) => col.sunatMessage} />
        <ExcelColumn
          label="Descripcion Detallada del Servicio o Bien"
          value="description"
        />
        <ExcelColumn label="Código del Bien o Servicio" value="serviceCode" />
        <ExcelColumn label="Monto de la Detracción" value="amountDetraction" />
        <ExcelColumn label="Porcentaje de Detracción" value="percentageDetraction" />
        <ExcelColumn label="Forma de Pago" value="currency" />
        <ExcelColumn label="Estado de Pago" value={(col) => col.descPayment} />
        <ExcelColumn label="Area" value={(col) => col.area} />
        <ExcelColumn label="Compañia" value="company" />
      </ExcelSheet>
    </ExcelFile>
  );
};

ExcelSchema.propType = {
  data: PropTypes.array,
};

ExcelSchema.defaultProps = {
  data: [],
};

export default ExcelSchema;
